import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

export function useUTMParameters() {
  const router = useRouter();
  const { utm_source, utm_medium, utm_campaign } = router.query;

  const [referrer, setReferrer] = useState('');

  useEffect(() => {
    if (typeof document !== 'undefined') {
      const currentReferrer = document.referrer;
      setReferrer(currentReferrer);
    }
  }, []);

  const UTMSource = utm_source || null;
  const UTMMedium = utm_medium || null;
  const UTMCampaign = utm_campaign || null;

  return {
    utm_source: UTMSource,
    utm_medium: UTMMedium,
    utm_campaign: UTMCampaign,
    referrer,
  };
}
